// shortcutRegistry.js
//
// DAS-2997: the ONE list of menu items that can be switched on as a homepage
// shortcut (Maintenance -> Expand Shortcuts), and the menu key each one opens.
//
// Before this, the same list was typed out twice — the names in
// MaintenanceModal.jsx and a label->key map in Homepage.jsx — and neither was
// tied to the real menus. Every new menu item had to be added in both places by
// hand. DAS-2992 added "Releasenotes" to the Account menu but not here, so it
// never appeared as a shortcut option; seven other items had drifted the same
// way (Prime Objective, Broad Picture, Portfolio Analysis, LLM Models, ...).
//
// `name` is what is STORED in the Shortcut_buttons table, so existing names
// must never change or the owner's enabled shortcuts silently switch off.
// shortcutRegistry.test.js fails when a real menu item is missing from here.

export const TOOLS_SHORTCUTS = [
  { name: 'Filter', key: 'filter' },
  { name: 'ETF Screener', key: 'etf_screener' },
  { name: 'Favorites', key: 'favorites' },
  { name: 'LLM', key: 'llm' },
  { name: 'Investment Goals', key: 'investment_goals' },
  { name: 'Charts', key: 'charts' },
  { name: 'ESG Check', key: 'esg_check' },
  { name: 'Ask', key: 'ask' },
  { name: 'Company Trends', key: 'trends' },
  { name: 'Sector Health Check', key: 'sector_summary' },
  { name: 'Sector Overview', key: 'sector_overview' },
  { name: 'Broad Picture', key: 'broad_picture' },           // DAS-2997: was missing
  { name: 'Portfolio Analysis', key: 'portfolio_analysis' },  // DAS-2997: was missing
];

export const ACCOUNT_SHORTCUTS = [
  { name: 'Investment Strategy', key: 'investment_strategy' },
  { name: 'Category Preferences', key: 'category_preferences' },
  { name: 'Data Preferences', key: 'data_preferences' },
  { name: 'Broker Access', key: 'broker_access' },
  { name: 'Logout', key: 'logout' },
  { name: 'Maintenance', key: 'maintenance' },
  { name: 'Market Alerts', key: 'market_alerts' },
  { name: 'Clauses', key: 'clauses' },
  { name: 'Alert-Scopes', key: 'alert_scopes' },
  { name: 'Alert Effectiveness', key: 'alert_effectiveness' },
  { name: 'Alert Discovery', key: 'alert_discovery' },
  { name: 'Portfolio Data Management', key: 'portfolio_data_management' },
  { name: 'Script Reporting', key: 'script_reporting' },
  { name: 'Ticker Maintenance', key: 'ticker_maintenance' },
  { name: 'Redux', key: 'redux_view' },
  { name: 'Backtesting', key: 'backtesting' },
  { name: 'ESG Checker', key: 'esg_checker' },
  { name: 'Trendsearch', key: 'trendsearch_management' },
  { name: '💡 AI Ideas (Dev)', key: 'ai_ideas' },
  { name: 'Releasenotes', key: 'release_notes' },                            // DAS-2997: the reported one
  { name: 'Prime Objective', key: 'prime_objective' },                      // DAS-2997: was missing
  { name: 'Find Databases, Tables, Fields', key: 'database_schema_search' }, // DAS-2997: was missing
  { name: 'LLM Models', key: 'llm_models' },                                // DAS-2997: was missing
  { name: 'DeGiro spike', key: 'degiro_spike' },                            // DAS-2997: was missing
  { name: '🛡️ Security Audit (Dev)', key: 'security_audit' },               // DAS-2997: was missing
  { name: 'Advice pipeline', key: 'advice_pipeline' },                      // DAS-3237
];

const toMap = (list) => Object.fromEntries(list.map(({ name, key }) => [name, key]));

export const toolsLabelToKey = toMap(TOOLS_SHORTCUTS);
export const accountLabelToKey = toMap(ACCOUNT_SHORTCUTS);
